// Hydration-safe date formatter: forces UTC so SSR and client always agree.
export function formatDateBR(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const year = d.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

// Hydration-safe date+time formatter in America/Sao_Paulo (BRT, UTC-3).
// Applies a manual -3h offset over UTC so SSR and client render identically,
// regardless of the viewer's local timezone.
export function formatDateTimeBR(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const brt = new Date(d.getTime() - 3 * 60 * 60 * 1000);
  const day = String(brt.getUTCDate()).padStart(2, "0");
  const month = String(brt.getUTCMonth() + 1).padStart(2, "0");
  const year = brt.getUTCFullYear();
  const hh = String(brt.getUTCHours()).padStart(2, "0");
  const mm = String(brt.getUTCMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} às ${hh}:${mm}`;
}
